module.exports = [
  ...require('./d'),
  ...require('./f'),
  ...require('./g'),
  ...require('./i'),
  ...require('./j'),
  ...require('./m'),
]
